import { render, staticRenderFns } from "./delivery-express.vue?vue&type=template&id=7f5975c8&scoped=true"
import script from "./delivery-express.vue?vue&type=script&lang=js"
export * from "./delivery-express.vue?vue&type=script&lang=js"
import style0 from "./delivery-express.vue?vue&type=style&index=0&id=7f5975c8&prod&lang=scss&scoped=true"
import style1 from "./delivery-express.vue?vue&type=style&index=1&id=7f5975c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5975c8",
  null
  
)

export default component.exports